module.exports = __webpack_public_path__ + "static/media/PDF_70.0a1c17b1.pdf";